<template>
  <v-container>
    <v-card style="padding: 10px">
      <v-card-title>
        <div style="width: 100%">
          KITOBLAR
        </div>
        <form
          style="width: 100%; margin-top: 30px"
          novalidate
          @submit.prevent="getPage()"
        >
          <v-row>
            <v-col sm="6" lg="3" md="6">
              <v-text-field
                dense
                outlined
                v-model="criteria.name"
                label="NOMI"
              />
            </v-col>
            <v-col sm="6" lg="3" md="6">
              <v-text-field
                dense
                outlined
                v-model="criteria.author"
                label="AVTOR"
              />
            </v-col>
            <v-col sm="6" lg="3" md="6">
              <v-select
                dense
                :items="departments"
                :item-text="(item) => item.name"
                :item-value="(item) => item.id"
                label="KAFEDRA"
                v-model="criteria.departmentId"
                outlined
              ></v-select>
            </v-col>
            <v-col sm="6" lg="3" md="6">
              <v-select
                dense
                :items="categories"
                :item-text="(item) => item.name"
                :item-value="(item) => item.id"
                label="BO'LIM"
                v-model="criteria.categoryId"
                outlined
              />
            </v-col>
            <v-col sm="12" md="12">
              <v-btn color="info" type="submit" class="float-right"
                ><v-icon >mdi-magnify</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </form>
        <v-row>
        <v-btn class="info" color="indigo" @click="$router.push('/book-edit')">Yangi qo'shish</v-btn>
        </v-row></v-card-title>
      <v-data-table hide-default-footer :headers="headers" :items="items">
        <template v-slot:item.action="{ item }">
          <v-btn-toggle>
            <v-btn small color="primary" @click="view(item)">
              <v-icon small color="white">mdi-eye</v-icon>
            </v-btn>

            <v-btn
              small
              color="info"
              @click="$router.push(`/book-edit/${item.id}`)"
            >
              <v-icon small color="white">mdi-pencil</v-icon>
            </v-btn>
            <v-btn small color="red" @click="deleteItem(item)">
              <v-icon small color="white">mdi-delete</v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-pagination
          v-model="currentPage"
          :length="pageable.totalPages"
          :total-visible="7"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
        ></v-pagination>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">KITOBNI KO'RISH</v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="12" md="12">
              <h2 class="text-center">
                {{ selectedBook.name }}
              </h2>
            </v-col>
            <v-col md="6" sm="12">
              <v-col sm="12" md="12"
                ><b>AVTOR:</b> {{ selectedBook.author }}
              </v-col>
              <v-col sm="12" md="12"
                ><b>NASHR ETILGAN YILI:</b> {{ selectedBook.year }}
              </v-col>
              <v-col sm="12" md="12"
                ><b>KAFEDRA:</b> {{ selectedBook.departmentName }}
              </v-col>
              <v-col sm="12" md="12"
                ><b>BO'LIM:</b> {{ selectedBook.categoryName }}
              </v-col>
              <v-col sm="12" v-if="hasBook" md="12">
                <qrcode-vue
                  class="mx-5"
                  :value="`${uploadUrl}/${selectedBook.fileUrl}`"
                ></qrcode-vue>
              </v-col>
            </v-col>
            <v-col v-if="hasBook" sm="12" md="6">
              <v-col sm="12" md="12">
                <a
                  :href="`${uploadUrl}/${selectedBook.fileUrl}`"
                  :download="selectedBook.name"
                >
                  <img
                    :src="`${uploadUrl}/${selectedBook.imageUrl}`"
                    style="width: 100%"
                  />
                </a>
              </v-col>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false"
            >ORTGA</v-btn
          >
        </v-card-actions>
      </v-card>
      <v-snackbar :value="snackbar" color="success" outlined right>
        Kitob ochrildi!
      </v-snackbar>
    </v-dialog>
  </v-container>
</template>
<script>
import service from "./book.service";
import dService from "../department/department.service";
import cService from "../category/category.service";
import QrcodeVue from "qrcode.vue";

export default {
  components: {
    QrcodeVue,
  },
  data: () => ({
    snackbar: false,
    currentPage: 1,
    uploadUrl: 'https://library.andqxai.uz/uploads',
    dialog: false,
    headers: [
      {
        text: "NOMI",
        value: "name",
        divider: "true",
        align: "start",
        width: "20%",
      },
      {
        text: "AVTOR",
        value: "author",
        divider: "true",
        align: "center",
        width: "20%",
      },
      {
        text: "YIL",
        value: "year",
        divider: "true",
        align: "center",
        width: "10%",
      },
      {
        text: "KAFEDRA",
        value: "departmentName",
        divider: "true",
        align: "center",
        width: "20%",
      },
      {
        text: "BO'LIM",
        value: "categoryName",
        divider: "true",
        align: "center",
        width: "20%",
      },
      {
        text: "",
        value: "action",
        align: "center",
        width: "10%",
      },
    ],
    books: [],
    departments: [],
    categories: [],
    criteria: {
      name: "",
      author: "",
      departmentId: "",
      categoryId: "",
    },
    pageable: {
      page: 0,
      size: 10,
      sort: "desc",
      sortBy: "id",
      totalPages: 1,
    },
    selectedBook: {
      name: "",
      author: "",
      year: "",
      departmentId: "",
      departmentName: "",
      categoryId: "",
      categoryName: "",
      fileUrl: "",
      imageUrl: "",
    },
  }),
  methods: {
    getPage() {
      service.getAll(this.pageable, this.criteria).then((res) => {
        this.books = res.data.content;
        this.pageable.totalPages = res.data.totalPages
      });
    },
    getOtherEntities() {
      dService.getAll().then((res) => {
        this.departments = [{ id: "", name: "Barchasi" }, ...res.data];
      });
      cService.getAll().then((res) => {
        this.categories = [{ id: "", name: "Barchasi" }, ...res.data];
      });
    },
    initial() {
      this.getPage();
      this.getOtherEntities();
    },
    view(item) {
      this.selectedBook = item;
      this.dialog = true;
    },
    deleteItem(item) {
      confirm("Ma'lumotlarni ochirishni tasdiqlaysizmi?") &&
        service
          .delete(item)
          .then(() => {
            this.getPage();
            this.snackbar = true;
          })
          .catch((err) => {
            alert(err);
          });
    },
  },
  created() {
    this.initial();
  },
  computed: {
    items() {
      return this.books;
    },
    hasBook() {
      return !(
        this.selectedBook.fileUrl === "" || this.selectedBook.fileUrl == null
      );
    },
  },
  watch: {
    currentPage(newVal) {
      if (newVal > 0) {
        this.pageable.page = newVal - 1;
        this.getPage();
      }
    },
  },
};
</script>
